import {
    Object3D,
    SphereBufferGeometry,
    MeshLambertMaterial,
    Mesh,
    LineBasicMaterial,
    Geometry,
    Vector3,
    Line,
    Sprite,
    SpriteMaterial,
    PlaneBufferGeometry,
    Color,
    DoubleSide
} from "three";
import bidello,{component} from "bidello";
import camera from "../camera";
import {CSS2DObject} from "three/examples/jsm/renderers/CSS2DRenderer";
import * as THREE from 'three';
import TWEEN from 'three/examples/jsm/libs/tween.module.min';
import {degToRad} from "math-toolbox";
import {viewport} from "../bidello";

export class Planet extends component(Object3D){

    init(){


        this.safeFrameSize = viewport.isVertical ? 0.45 : 0.35
        this.planetScale = 1;
        this.revolutionDays = 30;
        this.orbitalDays = 1
        this.label = "Planet";
        this.rotationAllowed = true;
        this.sizeInKm = Planet.REAL_SUN_SIZE;
        this.atmosphereSpriteMaterial = new SpriteMaterial({color:0xEEAA55,transparent:true});
        this.interactiveSpriteMaterial = new SpriteMaterial({color:0x000000,transparent:true,opacity:0});
        this.atmosphereSprite = new Sprite(this.atmosphereSpriteMaterial);
        this.atmosphereSprite.scale.set(this.planetScale*0.8,this.planetScale*0.8,this.planetScale*0.8)
        this.interactiveSprite = new Sprite(this.interactiveSpriteMaterial);
        this.viewGroup = new Object3D();
        this.planetGroup = new Object3D();
        this.planetInfo = new Object3D();


        this.orbitLineMaterial = new LineBasicMaterial( {
            color: 0xffffff,
            linewidth: 1,
            linecap: 'round', //ignored by WebGLRenderer
            linejoin:  'round' //ignored by WebGLRenderer
        } );
        this.orbitLineMaterial = new LineBasicMaterial({color:0xFFFFFF,transparent:true,opacity:0.25});
        this.orbitGeometry = this.getCircleGeometry(5,0.01);
        this.orbitLine = new Line(this.orbitGeometry,this.orbitLineMaterial);

        this.orbitFadeTween  = new TWEEN.Tween(this.orbitLineMaterial);

        this.sunSize = camera.getMinViewportUnitSize()*0.35;
        this.interactiveSprite.scale.multiplyScalar(camera.getMinViewportUnitSize());


        this.ringMaterial = new MeshLambertMaterial({color:0x67605E});
        this.ringPlane = new PlaneBufferGeometry(camera.getMinViewportUnitSize()*0.35,camera.getMinViewportUnitSize()*0.35,10,10)
        this.ringMesh = new Mesh(this.ringPlane,this.ringMaterial)
        this.ringMaterial.side = DoubleSide
        this.ringMesh.visible = false;

        this.planetTexture = new MeshLambertMaterial();
        this.planetGeometry = new SphereBufferGeometry(camera.getMinViewportUnitSize()*this.safeFrameSize,32,32);
        this.planetMesh = new Mesh(this.planetGeometry,this.planetTexture);
        this.planetMesh.rotateX(Math.PI*-0.5)
        this.atmosphereSprite.scale.multiplyScalar(camera.getMinViewportUnitSize());

        this.celestialBodyGroup = new Object3D();
        this.planetGroup.add(this.planetMesh);
        this.planetGroup.add(this.ringMesh);
        this.planetInfo.add(this.planetGroup)
        this.planetGroup.add(this.interactiveSprite)
        this.createLabel();
        this.viewGroup.add(this.planetInfo);
        this.viewGroup.add(this.orbitLine);
        this.viewGroup.rotateX(Math.PI/2)
        this.viewGroup.add(this.celestialBodyGroup);
        this.add(this.viewGroup);
        this.name = "planet";
    }

    setLabel (label){

        this.label = label;
        this.labelCSS3D.element.textContent = this.label;
    }

    setLabelVisibility (visible = true){

        if (!visible)this.labelCSS3D.element.textContent = "";
        if (visible)this.labelCSS3D.element.textContent = this.label;

    }

    createLabel (){

        const labelElement = document.createElement('div');
        labelElement.classList.add("planet-label");
        labelElement.classList.add("text-uppercase");
        //labelElement.classList.add("text--emphasis");
        labelElement.classList.add("font-color--white");
        labelElement.classList.add("font-size--paragraph");
        labelElement.textContent = "planet";
        this.labelCSS3D = new CSS2DObject(labelElement);
        this.labelCSS3D.scale.multiplyScalar(0.01)
        this.labelCSS3D.position.setZ(camera.calculateUnitSize().height*0.5)
        this.planetGroup.add(this.labelCSS3D)

    }

    setMaterial (texture){

        this.planetTexture.map = texture;
        this.planetTexture.needsUpdate = true;

    }

    setRingMaterial (texture){

        this.ringMaterial.map = texture;
        this.ringMaterial.needsUpdate = true;
        this.ringMesh.visible = true;

    }

    setRingSize (size=1){

        this.ringMesh.scale.multiplyScalar(size)

    }

    setAxisAngle (rotation=1){

        this.planetGroup.rotateX(degToRad(rotation))

    }

    setAtmosphereMaterial (texture,color=0xFFFFFF){

        this.atmosphereSprite.material.map = texture;
        this.atmosphereSprite.material.alphaMap = texture;
        this.atmosphereSprite.material.color = new Color(color);
        this.planetGroup.add(this.atmosphereSprite);

    }

    setRealSize (sizeInKm, compensate = 1){

        let planetScale = sizeInKm/Planet.REAL_SUN_SIZE;
        this.planetScale = planetScale*compensate;
        console.log(this.planetScale);
        if (this.planetScale<0.1)this.planetScale = 0.1
        this.planetMesh.scale.multiplyScalar(this.planetScale );
        this.labelCSS3D.position.multiplyScalar(this.planetScale );
        this.celestialBodyGroup.position.copy(this.planetGroup.position );
        this.atmosphereSprite.scale.multiplyScalar(this.planetScale*0.8)
        this.interactiveSprite.scale.multiplyScalar(this.planetScale);
        this.ringMesh.scale.multiplyScalar(this.planetScale*2);

    }

    setSunDistance (sizeInKm){

        const distanceInSunSize = sizeInKm/Planet.REAL_SUN_SIZE;
        this.planetGroup.position.setX(this.sunSize*distanceInSunSize);
        this.celestialBodyGroup.position.copy(this.planetGroup.position)
        this.orbitLine.geometry = this.getCircleGeometry(50,this.sunSize*distanceInSunSize*1)

    }

    addCelestialBody (object3D){

        console.log(this.celestialBodyGroup)
        this.celestialBodyGroup.add(object3D);
        //this.celestialBodyGroup.position.copy(this.planetGroup)

    }

    getCircleGeometry (segment = 10,radius = 1){

        const circleGeometry = new Geometry();
        for (var i = 0; i <= segment; i++) {
            var theta = (i / segment) * Math.PI * 2;
            circleGeometry.vertices.push(
                new Vector3(
                    Math.cos(theta) * radius,
                    Math.sin(theta) * radius,
                    0));
        }

        return circleGeometry;

    }

    onRaf(delta){

        this.planetGroup.rotation.z+=(0.01/this.revolutionDays);
        //if (this.rotationAllowed)this.viewGroup.rotation.z+=(0.001/this.orbitalDays);

    }

    onResize (viewPort){

        //this.setRealSize(this.sizeInKm);

    }

    setDaysTillBigBang (days){

        this.viewGroup.rotation.z+=(0.001/this.orbitalDays)*days;

    }

    hideOrbit (){

        this.orbitFadeTween.to({opacity:0},700).start();

    }
    showOrbit (){

        this.orbitFadeTween.to({opacity:0.25},700).start()

    }


}

Planet.REAL_SUN_SIZE = 1392000;
Planet.MIN_PLANET_SCALE = 0.5;

